import type { Step } from "react-joyride";

export const meetingFormCreateTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ສ້າງບັນທຶກການປະຊຸມໃໝ່. ປ້ອນວັນທີ, ຫົວຂໍ້, ສະຫຼຸບ, ເພີ່ມຜູ້ຮ່ວມ ແລະ ປະເດັນທີ່ລົມກັນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="meeting-form-create-back"]',
    content:
      "ກັບຄືນໄປຫນ້າລາຍການບັນທຶກການປະຊຸມ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="meeting-form-form"]',
    content:
      "ແບບຟອມ: ວັນທີປະຊຸມ, ຫົວຂໍ້, ສະຫຼຸບ, ຜູ້ຮ່ວມ ແລະ ປະເດັນ. ກົດບັນທຶກເພື່ອສ້າງບັນທຶກການປະຊຸມ.",
    placement: "top",
  },
];
